/* CUSTOM-START: Spotlight arama — CUSTOMIZATIONS.md#spotlight
 *
 * Header arama panelini Raycast/Spotlight gibi çalıştırır:
 *   yazarken gri tamamlama + öneri listesi → Tab / → / Enter (oklarla seçince) / tıklama ile kabul → ikonlu çip.
 * Çip türleri: kategori, marka, filtre değeri (switch türü, boyut…), fiyat, stok.
 *   - Filtre/fiyat/stok çipleri formda gizli <input name="filter.…"> olarak durur (URL filtresi, kesin daraltma).
 *   - Marka/kategori: S&D'de Vendor/Product type filtresi kayıtlıysa URL filtresi, değilse arama sözdizimi
 *     (vendor:"X" / product_type:"X"). Dizin hangisinin geçerli olduğunu söyler (vendorFiltre / tipFiltre).
 * theme.js (PredictiveSearch) aramayı window.spotlight.istek() ile kurar.
 * Dizin: snippets/spotlight-index.liquid (scripts/spotlight-index.py üretir).
 */
(() => {
  const dizinEl = document.getElementById('spotlight-index');
  const form = document.querySelector('#search-drawer form[role="search"]');
  if (!dizinEl || !form || window.spotlight) return;

  const D = JSON.parse(dizinEl.textContent);
  const kutu = form.querySelector('.search-input');
  const input = form.elements.q;
  if (!kutu || !input) return;

  const MAKS_CIP = 12;   // 6'ydı: klavyede 6 filtreden sonra 7.si (Klavye Türü) eklenemiyordu (kullanıcı testi 14.10)
  const SON_ANAHTAR = 'spotlight-son';

  /* ================= yardımcılar ================= */
  const HARF = { ı: 'i', ş: 's', ğ: 'g', ü: 'u', ö: 'o', ç: 'c', '×': 'x', â: 'a', î: 'i', û: 'u' };
  const norm = (s) => String(s).toLocaleLowerCase('tr').replace(/[ışğüöç×âîû]/g, (h) => HARF[h]).replace(/[()]/g, '').replace(/\s+/g, ' ').trim();
  const tl = (n) => `${Number(n).toLocaleString('tr-TR')} TL`;
  const esc = (s) => String(s).replace(/[&<>"]/g, (h) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[h]));

  /* tek harf hata (silme/ekleme/değiştirme/yer değiştirme) toleransı: a ile b'nin aynı uzunluktaki başı */
  function birHata(a, b) {
    if (Math.abs(a.length - b.length) > 1) return false;
    let i = 0, j = 0, hata = 0;
    while (i < a.length && j < b.length) {
      if (a[i] === b[j]) { i++; j++; continue; }
      if (++hata > 1) return false;
      if (a[i] === b[j + 1] && a[i + 1] === b[j]) { i += 2; j += 2; continue; }   // yer değiştirme
      if (a.length > b.length) i++; else if (a.length < b.length) j++; else { i++; j++; }
    }
    return hata + (a.length - i) + (b.length - j) <= 1;
  }

  /* İkonlar: Lucide (https://lucide.dev, ISC lisansı) — sadece iç SVG öğeleri; çerçeve svg() içinde */
  const IKON = {
    keyboard: '<path d="M10 8h.01"/> <path d="M12 12h.01"/> <path d="M14 8h.01"/> <path d="M16 12h.01"/> <path d="M18 8h.01"/> <path d="M6 8h.01"/> <path d="M7 16h10"/> <path d="M8 12h.01"/> <rect width="20" height="16" x="2" y="4" rx="2"/>',   // keyboard
    mouse: '<rect x="5" y="2" width="14" height="20" rx="7"/> <path d="M12 6v4"/>',   // mouse
    mousepad: '<path d="M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z"/> <path d="M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6"/>',   // square-mouse-pointer
    iem: '<path d="M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3"/>',   // headphones
    gamepad: '<line x1="6" x2="10" y1="11" y2="11"/> <line x1="8" x2="8" y1="9" y2="13"/> <line x1="15" x2="15.01" y1="12" y2="12"/> <line x1="18" x2="18.01" y1="10" y2="10"/> <path d="M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 0 1 9.828 16h4.344a2 2 0 0 1 1.414.586L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.545-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0 0 17.32 5z"/>',   // gamepad-2
    audio: '<rect width="16" height="20" x="4" y="2" rx="2"/> <path d="M12 6h.01"/> <circle cx="12" cy="14" r="4"/> <path d="M12 14h.01"/>',   // speaker
    mic: '<path d="M12 19v3"/> <path d="M19 10v2a7 7 0 0 1-14 0v-2"/> <rect x="9" y="2" width="6" height="13" rx="3"/>',   // mic
    camera: '<circle cx="12" cy="10" r="8"/> <circle cx="12" cy="10" r="3"/> <path d="M7 22h10"/> <path d="M12 22v-4"/>',   // webcam
    switch: '<rect width="18" height="18" x="3" y="3" rx="2"/> <circle cx="12" cy="12" r="1"/>',   // square-dot
    keycap: '<path d="M12 4v16"/> <path d="M4 7V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2"/> <path d="M9 20h6"/>',   // type
    grip: '<circle cx="12" cy="5" r="1"/> <circle cx="19" cy="5" r="1"/> <circle cx="5" cy="5" r="1"/> <circle cx="12" cy="12" r="1"/> <circle cx="19" cy="12" r="1"/> <circle cx="5" cy="12" r="1"/> <circle cx="12" cy="19" r="1"/> <circle cx="19" cy="19" r="1"/> <circle cx="5" cy="19" r="1"/>',   // grip
    monitor: '<rect width="20" height="14" x="2" y="3" rx="2"/> <line x1="8" x2="16" y1="21" y2="21"/> <line x1="12" x2="12" y1="17" y2="21"/>',   // monitor
    case: '<rect width="14" height="20" x="5" y="2" rx="2"/> <path d="M15 14h.01"/> <path d="M9 6h6"/> <path d="M9 10h6"/>',   // pc-case
    fan: '<path d="M10.827 16.379a6.082 6.082 0 0 1-8.618-7.002l5.412 1.45a6.082 6.082 0 0 1 7.002-8.618l-1.45 5.412a6.082 6.082 0 0 1 8.618 7.002l-5.412-1.45a6.082 6.082 0 0 1-7.002 8.618l1.45-5.412Z"/> <path d="M12 12v.01"/>',   // fan
    cable: '<path d="M17 19a1 1 0 0 1-1-1v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a1 1 0 0 1-1 1z"/> <path d="M17 21v-2"/> <path d="M19 14V6.5a1 1 0 0 0-7 0v11a1 1 0 0 1-7 0V10"/> <path d="M21 21v-2"/> <path d="M3 5V3"/> <path d="M4 10a2 2 0 0 1-2-2V6a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2z"/> <path d="M7 5V3"/>',   // cable
    pcb: '<path d="M12 20v2"/> <path d="M12 2v2"/> <path d="M17 20v2"/> <path d="M17 2v2"/> <path d="M2 12h2"/> <path d="M2 17h2"/> <path d="M2 7h2"/> <path d="M20 12h2"/> <path d="M20 17h2"/> <path d="M20 7h2"/> <path d="M7 20v2"/> <path d="M7 2v2"/> <rect x="4" y="4" width="16" height="16" rx="2"/> <rect x="8" y="8" width="8" height="8" rx="1"/>',   // cpu
    wrist: '<path d="M18 11V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2"/> <path d="M14 10V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2"/> <path d="M10 10.5V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2v8"/> <path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15"/>',   // hand
    dongle: '<circle cx="10" cy="7" r="1"/> <circle cx="4" cy="20" r="1"/> <path d="M4.7 19.3 19 5"/> <path d="m21 3-3 1 2 2Z"/> <path d="M9.26 7.68 5 12l2 5"/> <path d="m10 14 5 2 3.5-3.5"/> <path d="m18 12 1-1 1 1-1 1Z"/>',   // usb
    tag: '<path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"/> <circle cx="7.5" cy="7.5" r=".5" fill="currentColor"/>',   // tag
    price: '<path d="M15 4 5 9"/> <path d="m15 8.5-10 5"/> <path d="M18 12a9 9 0 0 1-9 9V3"/>',   // turkish-lira
    stock: '<path d="M12 22V12"/> <path d="m16 17 2 2 4-4"/> <path d="M21 11.127V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.729l7 4a2 2 0 0 0 2 .001l1.32-.753"/> <path d="M3.29 7 12 12l8.71-5"/> <path d="m7.5 4.27 8.997 5.148"/>',   // package-check
    clock: '<path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/> <path d="M3 3v5h5"/> <path d="M12 7v5l4 2"/>',   // history
    mute: '<path d="M11 4.702a.7.7 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.7.7 0 0 0 11 19.298z"/> <path d="m16.5 14.5 5-5"/> <path d="m16.5 9.5 5 5"/>',   // volume-x
    tactile: '<path d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2"/>',   // activity
    linear: '<path d="M12 17V3"/> <path d="m6 11 6 6 6-6"/> <path d="M19 21H5"/>',   // arrow-down-to-line
    clicky: '<path d="M14 4.1 12 6"/> <path d="m5.1 8-2.9-.8"/> <path d="m6 12-1.9 2"/> <path d="M7.2 2.2 8 5.1"/> <path d="M9.037 9.69a.498.498 0 0 1 .653-.653l11 4.5a.5.5 0 0 1-.074.949l-4.349 1.041a1 1 0 0 0-.74.739l-1.04 4.35a.5.5 0 0 1-.95.074z"/>',   // mouse-pointer-click
    swap: '<path d="M8 3 4 7l4 4"/> <path d="M4 7h16"/> <path d="m16 21 4-4-4-4"/> <path d="M20 17H4"/>',   // arrow-left-right
    trend: '<path d="M16 7h6v6"/> <path d="m22 7-8.5 8.5-5-5L2 17"/>',   // trending-up
    grid: '<rect width="7" height="7" x="3" y="3" rx="1"/> <rect width="7" height="7" x="14" y="3" rx="1"/> <rect width="7" height="7" x="14" y="14" rx="1"/> <rect width="7" height="7" x="3" y="14" rx="1"/>',   // layout-grid
    award: '<path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"/> <circle cx="12" cy="8" r="6"/>',   // award
    sliders: '<path d="M10 5H3"/> <path d="M12 19H3"/> <path d="M14 3v4"/> <path d="M16 17v4"/> <path d="M21 12h-9"/> <path d="M21 19h-5"/> <path d="M21 5h-7"/> <path d="M8 10v4"/> <path d="M8 12H3"/>',   // sliders-horizontal
    ara: '<path d="m21 21-4.34-4.34"/> <circle cx="11" cy="11" r="8"/>',   // search
    ok: '<path d="M5 12h14"/> <path d="m12 5 7 7-7 7"/>',   // arrow-right
    yeni: '<path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"/> <path d="M20 2v4"/> <path d="M22 4h-4"/>',   // sparkles
    alev: '<path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/>',   // flame
    yildiz: '<path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"/>',   // star
    kapat: '<path d="M18 6 6 18"/> <path d="m6 6 12 12"/>',   // x
    geri: '<path d="m12 19-7-7 7-7"/><path d="M19 12H5"/>',   // arrow-left
  };
  const FILTRE_IKON = { klavye: 'keyboard', mouse: 'mouse', mousepad: 'mousepad', iem: 'iem', oyunkolu: 'gamepad' };
  const svg = (ad) => `<svg class="spotlight-ikon" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${IKON[ad] || IKON.tag}</svg>`;
  // logosu olmayan marka: iki kelimeyse baş harfler (Uncle Panda → UP), bitişik yazılmışsa içteki büyük harf (GamePower → GP), yoksa ilk iki harf (MOJHON → MO)
  const kisaltma = (ad) => {
    const k = ad.split(/[^\p{L}\p{N}]+/u).filter(Boolean);
    const ic = k.length === 1 && k[0].match(/^(\p{L})\p{Ll}+(\p{Lu})/u);
    return (k.length > 1 ? k[0][0] + k[1][0] : ic ? ic[1] + ic[2] : (k[0] || '').slice(0, 2)).toLocaleUpperCase('tr');
  };
  const monogram = (ad) => `<span class="spotlight-monogram">${esc(kisaltma(ad))}</span>`;
  const kutucuk = (ic) => `<span class="spotlight-ikon-kutu" aria-hidden="true">${ic}</span>`;   // her ikon aynı boyutta kutucukta
  // marka: keşif ekranındaki logo (çip, hap, kart hep aynı logo); yoksa baş harfler
  const ikonHtml = (j) => {
    const logo = j.tur === 'mrk' && kesfetGorseli(j.id)?.src;
    return logo ? `<span class="spotlight-ikon-kutu spotlight-ikon-kutu--logo" aria-hidden="true"><img src="${esc(logo)}" alt="" data-ad="${esc(j.l)}" loading="lazy"></span>` : kutucuk(j.tur === 'mrk' ? monogram(j.l) : svg(j.ikon));
  };

  /* ================= jetonlar (çip olabilecek her şey) ================= */
  const KAT_AD = { klavye: 'Klavye', mouse: 'Mouse', mousepad: 'Mousepad', iem: 'IEM', oyunkolu: 'Oyun Kolu' };
  const jetonlar = [];
  for (const k of D.kategoriler) {
    jetonlar.push({ tur: 'kat', id: `kat:${k.l}`, l: k.l, alt: 'Kategori', ikon: k.i, c: k.c, n: k.n, tip: k.tip, t: [norm(k.l), ...k.k.map(norm)] });
  }
  for (const m of D.markalar) {
    jetonlar.push({ tur: 'mrk', id: `mrk:${m.l}`, l: m.l, alt: 'Marka', c: null, cs: m.cs, n: m.n, t: [norm(m.l)] });
  }
  for (const d of D.degerler) {
    jetonlar.push({ tur: 'deg', id: `${d.p}|${d.v}`, l: d.l, alt: `${d.f} · ${KAT_AD[d.c]}`, alt1: d.f, alt2: KAT_AD[d.c], ikon: FILTRE_IKON[d.c], c: d.c, n: d.n, p: d.p, v: d.v, t: [norm(d.l), ...d.k.map(norm)] });
  }
  // özellik çipleri: S&D filtresi yok, aramaya düz metin olarak eklenir (sessiz → silent)
  for (const o of D.ozellikler || []) {
    jetonlar.push({ tur: 'ozl', id: `ozl:${o.q}`, l: o.l, alt: 'Özellik', ikon: o.i, c: null, n: o.n, metin: o.q, t: [norm(o.l), ...o.k.map(norm)] });
  }
  const STOK = { tur: 'stok', id: 'stok', l: 'Stokta', alt: 'Stok durumu', ikon: 'stock', c: null, n: 0, t: ['stokta', 'stokta var', 'stok', 'mevcut', 'in stock'] };
  jetonlar.push(STOK);
  const jetonBul = (id) => jetonlar.find((j) => j.id === id);

  const fiyatJeton = (min, max) => {
    const l = min != null && max != null ? `${tl(min)} – ${tl(max)}` : min != null ? `${tl(min)} ve üstü` : `${tl(max)} ve altı`;
    return { tur: 'fiyat', id: `fiyat:${min ?? ''}-${max ?? ''}`, l, alt: 'Fiyat', ikon: 'price', c: null, n: 0, min, max };
  };
  const sayi = (s) => {
    const m = /^(\d+(?:[.,]\d{3})*)(k)?$/.exec(s.replace(/\s/g, ''));
    return m ? Number(m[1].replace(/[.,]/g, '')) * (m[2] ? 1000 : 1) : null;
  };
  /* "2000 alti", "2k altı", "1000-3000", "1000 ile 3000 arasi", "3000 ustu", "<2000", ">2000", "2000 tl" */
  function fiyatAdaylari(kuyruk) {
    const s = norm(kuyruk).replace(/\s*tl\b/g, '').replace(/₺/g, '');
    const N = '(\\d+(?:[.,]\\d{3})*k?)';
    let m;
    if ((m = new RegExp(`${N}\\s*(?:-|ile)\\s*${N}(?:\\s*arasi)?$`).exec(s))) {
      const a = sayi(m[1]), b = sayi(m[2]);
      if (a != null && b != null && a < b) return [{ j: fiyatJeton(a, b), parca: m[0] }];
    }
    if ((m = new RegExp(`(?:<\\s*|max\\s*)${N}$`).exec(s)) || (m = new RegExp(`${N}\\s*(?:ve\\s*)?(?:alti|altinda)$`).exec(s))) {
      const a = sayi(m[1]); if (a) return [{ j: fiyatJeton(null, a), parca: m[0] }];
    }
    if ((m = new RegExp(`(?:>\\s*|min\\s*)${N}$`).exec(s)) || (m = new RegExp(`${N}\\s*(?:ve\\s*)?(?:ustu|uzeri|ustunde)$`).exec(s))) {
      const a = sayi(m[1]); if (a) return [{ j: fiyatJeton(a, null), parca: m[0] }];
    }
    if (/tl\s*$|₺\s*$/i.test(norm(kuyruk)) && (m = new RegExp(`${N}$`).exec(s))) {
      const a = sayi(m[1]);
      if (a) return [{ j: fiyatJeton(null, a), parca: m[0] }, { j: fiyatJeton(a, null), parca: m[0] }];
    }
    return [];
  }

  /* ================= DOM ================= */
  // Kompakt Spotlight penceresi: tam ekran yerine üst-ortada panel, sonuçlar sekmeli (tema sekme modu), yukarıdan açılır
  const drawer = document.getElementById('search-drawer');
  if (drawer) {
    drawer.classList.add('spotlight-kompakt');
    drawer.classList.remove('search-drawer--full');
    drawer.setAttribute('open-from', 'top');
    // Bulanık arka plan panelin dışında (body'de): panel açılır açılmaz gelsin (CSS'teki .spotlight-arka notu)
    const arka = document.createElement('div');
    arka.className = 'spotlight-arka';
    arka.setAttribute('aria-hidden', 'true');
    document.body.append(arka);
    // body.spotlight-acik: panel açıkken üstte duran uygulama katmanları (Chatwoot, çerez barı, Loox) gizlenir (CSS'te)
    // kapanış sırası: önce panel (temanın kapanma animasyonu) kapanır, karartma sonra gider (kullanıcı geri bildirimi 14.10)
    const arkaGuncelle = async () => {
      if (drawer.hasAttribute('open')) {
        arka.classList.add('spotlight-arka--acik'); document.body.classList.add('spotlight-acik');
        if (input.value || secili.length) form.reset();   // her açılışta temiz kutu: yazı ve çip yok (kullanıcı 15.10)
        return;
      }
      await new Promise((r) => requestAnimationFrame(r));
      const anim = document.getAnimations().filter((a) => a.playState === 'running');
      await Promise.race([Promise.allSettled(anim.map((a) => a.finished)), new Promise((r) => setTimeout(r, 600))]);
      if (!drawer.hasAttribute('open')) { arka.classList.remove('spotlight-arka--acik'); document.body.classList.remove('spotlight-acik'); }
    };
    new MutationObserver(arkaGuncelle).observe(drawer, { attributes: true, attributeFilter: ['open'] });
    arkaGuncelle();
    const kapat = drawer.querySelector('.search-input > [is="close-button"]');
    if (kapat) kapat.title = 'Kapat (Esc)';
  }

  // Çipler yazı satırında (Spotlight gibi): çip şeridi + yazı kutusu ortak sarmalayıcıda, birlikte akar ve sarar
  const alan = document.createElement('div');
  alan.className = 'spotlight-alan';
  kutu.insertBefore(alan, input);
  const cipler = document.createElement('div');
  cipler.className = 'spotlight-cipler';
  alan.append(cipler, input);

  // arama satırının yüksekliği (çipler sarınca büyür): keşif menüsü ve önizleme paneli bunun altına yapışır
  if (drawer) new ResizeObserver(() => drawer.style.setProperty('--sp-satir', `${kutu.offsetHeight}px`)).observe(kutu);

  const golge = document.createElement('div');
  golge.className = 'spotlight-golge';
  golge.setAttribute('aria-hidden', 'true');
  kutu.append(golge);

  const liste = document.createElement('div');
  liste.className = 'spotlight-oneriler';
  liste.id = 'spotlight-oneriler';
  liste.setAttribute('role', 'listbox');
  liste.setAttribute('aria-label', 'Arama önerileri');
  liste.hidden = true;
  kutu.after(liste);
  // öneri listesinin yüksekliği: bölünmüş önizleme kalan alanı kullansın (panel dışarıdan ikinci kez kaymasın)
  if (drawer) new ResizeObserver(() => drawer.style.setProperty('--sp-oneri', `${liste.hidden ? 0 : liste.offsetHeight}px`)).observe(liste);

  const duyuru = document.createElement('div');
  duyuru.className = 'sr-only';
  duyuru.setAttribute('aria-live', 'polite');
  form.append(duyuru);

  const gizli = document.createElement('div');
  gizli.hidden = true;
  form.append(gizli);

  const kesfet = form.querySelector('[data-spotlight-kesfet]');   // arama boşken keşif ekranı
  // Marka logosu Files'ta `searchbar-logo-<marka>.png` (snippets/spotlight-kesfet). Dosya yüklenemezse kutuda ve çipte kısaltma kalır.
  form.addEventListener('error', (e) => {
    const g = e.target;
    if (g.matches?.('.spk-marka img')) { const m = g.closest('.spk-marka'); g.remove(); m.parentNode.append(m); gorselHaritasi = null; }
    else if (g.matches?.('.spotlight-ikon-kutu--logo img')) g.parentNode.outerHTML = kutucuk(monogram(g.dataset.ad || ''));
  }, true);
  // logosu olmayan markalar (kutuda kısaltma) Markalar sekmesinde ve şeritte sonda
  const markaPaneli = kesfet?.querySelector('[data-spk-panel="markalar"] .spk-markalar');
  markaPaneli?.querySelectorAll('.spk-marka').forEach((m) => { if (!m.querySelector('img')) markaPaneli.append(m); });

  input.setAttribute('role', 'combobox');
  input.setAttribute('aria-autocomplete', 'list');
  input.setAttribute('aria-controls', liste.id);
  input.setAttribute('aria-expanded', 'false');

  /* ================= durum ================= */
  let secili = [];          // çipler (jeton nesneleri)
  let satirlar = [];        // listede gösterilen [{j, parca, etiketle, baslik?}]
  let imlec = 0;
  let okKullanildi = false;
  let sonParca = '';
  let urunImlec = -1;       // ürün sonuçlarında klavye vurgusu

  const kilitKategori = () => secili.find((j) => j.c)?.c || null;
  const markaKategorileri = () => {
    const m = secili.filter((j) => j.tur === 'mrk');
    return m.length ? new Set(m.flatMap((j) => j.cs)) : null;
  };
  const yaziBaglami = () => {   // yazıda geçen kategori kelimesi ("kablosuz mouse") öneriyi o kategoriye yaklaştırır
    const s = ` ${norm(input.value)} `;
    return jetonlar.find((j) => j.tur === 'kat' && j.c && j.t.some((t) => t.length > 2 && s.includes(` ${t} `)))?.c || null;
  };

  // adım adım (kullanıcı isteği): marka seçili ama kategori yokken önce kategori — özellik filtresi (deg / ozl) önerilmez,
  // kategoriler de sadece markanın ürün sattıkları (dizindeki ks); kategori seçilince o kategorinin filtreleri açılır
  const markaKategoriSayilari = () => {
    const m = secili.filter((s) => s.tur === 'mrk');
    if (!m.length) return null;
    const say = {};
    m.forEach((x) => Object.entries(D.markalar.find((y) => y.l === x.l)?.ks || {}).forEach(([k, n]) => { say[k] = (say[k] || 0) + n; }));
    return say;
  };

  function uygunMu(j) {
    if (secili.some((s) => s.id === j.id)) return false;
    const kilit = kilitKategori();
    const markaKat = markaKategoriSayilari();
    if (markaKat && !secili.some((s) => s.tur === 'kat')) {
      if (j.tur === 'deg' || j.tur === 'ozl') return false;   // önce kategori seçilsin
      if (j.tur === 'kat' && !markaKat[j.l]) return false;   // markanın satmadığı kategori önerilmez
    }
    if (j.tur === 'deg') {
      if (kilit && j.c !== kilit) return false;
      const mk = markaKategorileri();
      if (mk && !mk.has(j.c)) return false;
    }
    if (j.tur === 'kat' && kilit && j.c !== kilit) return false;   // klavye filtresi + "Ses Kartı" her zaman 0 sonuç
    return true;
  }

  /* tekKelime: yazım hatası toleransı sadece tek kelimede (iki kelimelik bulanık eşleşme doğru tek kelimeyi ezmesin) */
  function puanla(j, p, tekKelime) {
    let puan = 0, etiketle = false;
    j.t.forEach((t, i) => {
      let s = 0;
      if (t === p) s = i === 0 ? 6 : 5;
      else if (t.startsWith(p)) s = i === 0 ? 4 : 3;
      else if (p.length >= 3 && t.includes(` ${p}`)) s = 2.5;
      else if (tekKelime && p.length >= 4 && [0, 1, -1].some((d) => birHata(p, t.slice(0, p.length + d)))) s = 1.5;
      if (s > puan) { puan = s; etiketle = i === 0 && t.startsWith(p); }
    });
    return { puan, etiketle };
  }

  /* Yazının sonundaki 1–4 kelimeden en uzun eşleşeni bulur. */
  function aday() {
    const metin = input.value;
    if (input.selectionStart !== metin.length || /\s$/.test(metin) || !metin.trim()) return { parca: '', bulunan: [] };
    const kelimeler = metin.trim().split(/\s+/);
    const tercih = kilitKategori() || yaziBaglami();
    for (let n = Math.min(4, kelimeler.length); n >= 1; n--) {
      const kuyruk = kelimeler.slice(-n).join(' ');
      const fiyat = fiyatAdaylari(kuyruk).filter(({ parca }) => norm(parca) === norm(kuyruk).replace(/\s*tl\b/g, '').replace(/₺/g, ''));
      if (fiyat.length) return { parca: kuyruk, bulunan: fiyat.map(({ j }) => ({ j, puan: 9, etiketle: false })) };
      if (n === 4) continue;
      const p = norm(kuyruk);
      if (p.length < 2) continue;
      const bulunan = [];
      for (const j of jetonlar) {
        if (!uygunMu(j)) continue;
        const { puan, etiketle } = puanla(j, p, n === 1);
        if (!puan) continue;
        const bonus = (tercih && j.c === tercih ? 1.5 : 0) + Math.log10((j.n || 0) + 1) * 0.6;
        bulunan.push({ j, puan: puan + bonus, etiketle });
      }
      if (bulunan.length) {
        bulunan.sort((a, b) => b.puan - a.puan || a.j.l.length - b.j.l.length);
        return { parca: kuyruk, bulunan: bulunan.slice(0, 7) };
      }
    }
    return { parca: '', bulunan: [] };
  }

  /* Kutu boşken gösterilenler: kategori seçiliyse o kategorinin popüler filtreleri, değilse son aramalar + kategoriler */
  /* Çip varken boş kutu: hep bir sonraki mantıklı adım, tek satır (kullanıcı onayı 13.10, artifact "Filtre Önerisi Senaryoları"):
     1) kategori belli değil (fiyat / stok / marka…) → "Kategori seç" (markanınkiler ürün sayısıyla, yoksa en çok ürünlü 6)
     2) filtreli kategori → o kategorinin filtre TÜRLERİ (Yüzey Tipi, Boyut…); türe tıklayınca aynı satır o türün bütün
        değerlerine döner (kullanıcı 13.10: tek değer gösterince "Kontrol var mı yok mu" bilinmiyordu), ‹ geri döner
     3) filtresi olmayan kategori ya da filtre kalmadı → hızlı filtreler (Stokta, 2.000 / 5.000 TL altı); o da yoksa satır yok */
  let acikGrup = null;   // açık filtre türü (jeton.p)
  // Değerlerin O ANKİ sonuçtaki ürün sayıları: sonuçlarla gelen <script class="spotlight-fasetler"> (sections/search-drawer.liquid,
  // search.filters). Yeni arama başlayınca null (bilinmiyor → sayı yazılmaz); 0 olan değer soluk, seçilmez.
  let faset = null;
  const fasetSayi = (j) => (faset?.[j.p] ? faset[j.p][j.v] || 0 : null);
  const secilemez = (s) => !!((s.sayi && fasetSayi(s.j) === 0) || (s.grup && s.grup.degerler.every((x) => fasetSayi(x) === 0)));   // !!: classList.toggle(…, undefined) tersine çevirir
  function sayilariYaz() {
    satirlar.forEach((s, i) => {
      if (!s.sayi && !s.grup) return;
      const el = document.getElementById(`spotlight-oneri-${i}`);
      if (!el) return;
      el.querySelector('.spotlight-oneri__alt').textContent = s.sayi ? fasetSayi(s.j) ?? '' : s.grup.degerler.filter((x) => fasetSayi(x) !== 0).length;
      el.classList.toggle('spotlight-oneri--yok', secilemez(s));
      el.setAttribute('aria-disabled', String(secilemez(s)));
    });
  }
  function fasetOku() {
    try { faset = JSON.parse(form.querySelector('[slot="results"] script.spotlight-fasetler')?.textContent || 'null'); } catch { faset = null; }
    sayilariYaz();
  }
  input.addEventListener('input', () => { faset = null; sayilariYaz(); });
  const fasetAlani = form.querySelector('predictive-search');   // tema sonuç bloğunu her aramada değiştirir
  if (fasetAlani) new MutationObserver(fasetOku).observe(fasetAlani, { childList: true });
  // ürün listesinin sonunda üstteki "ara" satırının aynısı: aşağı kaydıran tüm sonuçlara geçebilsin (kullanıcı 15.10)
  function listeSonuEkle() {
    const liste = form.querySelector('[slot="results"] .predictive-search__tab-content');   // ilk sekme = ürünler
    const yazi = input.value.trim();
    if (!liste || liste.querySelector('.spotlight-liste-sonu') || !liste.querySelector('a[href*="/products/"]') || !(yazi || secili.length)) return;
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'spotlight-oneri spotlight-oneri--ara spotlight-liste-sonu';
    b.innerHTML = `${kutucuk(svg('ara'))}<span class="spotlight-oneri__ad"></span><span class="spotlight-oneri__alt"></span>`;
    const baglam = secili.map((j) => j.l).join(' · ');
    b.querySelector('.spotlight-oneri__ad').textContent = yazi ? `“${yazi}” için tüm sonuçları gör` : 'Bu filtrelerle tüm ürünleri gör';
    b.querySelector('.spotlight-oneri__alt').textContent = baglam;
    b.addEventListener('click', () => form.requestSubmit());
    liste.append(b);
  }
  if (fasetAlani) {
    new MutationObserver(() => {
      listeSonuEkle();
      try { window.doublyChangeEvent?.(); } catch { /* Doubly: sonradan gelen .money fiyatları ("6,999.00TL" → "6,999.00 TL") */ }
    }).observe(fasetAlani, { childList: true });
  }
  function bosOneriler() {
    const kilit = kilitKategori();
    const markaKat = markaKategoriSayilari();
    if (markaKat && !secili.some((s) => s.tur === 'kat')) {
      const kat = jetonlar.filter((x) => x.tur === 'kat' && markaKat[x.l]).sort((a, b) => markaKat[b.l] - markaKat[a.l])
        .map((x) => ({ j: x, alt: `${markaKat[x.l]} ürün` }));   // alt sadece gösterim (çip asıl jetonu tutar)
      return kat.length ? [{ baslik: 'Kategori seç' }, ...kat] : [];
    }
    if (secili.length && !kilit && !secili.some((s) => s.tur === 'kat')) {
      const kat = jetonlar.filter((x) => x.tur === 'kat' && uygunMu(x)).sort((a, b) => b.n - a.n).slice(0, 6);
      return kat.length ? [{ baslik: 'Kategori seç' }, ...kat.map((x) => ({ j: x, altYok: true }))] : [];
    }
    if (secili.length) {
      let oneri = [];
      if (kilit) {
        // listeyi gerçekten bölen değerler öne: ~%50'yi kapsayan en iyi, neredeyse hepsini kapsayan (Kablolu 174/191) işe yaramaz
        const toplam = jetonlar.find((x) => x.tur === 'kat' && x.c === kilit)?.n || 0;
        const fayda = (x) => (toplam ? x.n * (1 - x.n / toplam) : x.n);
        const gruplar = new Map();   // filtre türü (p) → değerleri; değeri seçilmiş tür çıkar
        for (const x of jetonlar) {
          if (x.tur !== 'deg' || !uygunMu(x) || x.c !== kilit || secili.some((s) => s.p === x.p)) continue;
          gruplar.set(x.p, [...(gruplar.get(x.p) || []), x]);
        }
        if (gruplar.has(acikGrup)) {
          const d = gruplar.get(acikGrup).sort((a, b) => b.n - a.n);
          return [{ baslik: d[0].alt1, geri: true }, ...d.map((x) => ({ j: x, sayi: true }))];
        }
        const enIyi = (d) => Math.max(...d.map(fayda));
        oneri = [...gruplar.values()].sort((a, b) => enIyi(b) - enIyi(a)).map((d) => ({ grup: { p: d[0].p, ad: d[0].alt1, ikon: d[0].ikon, degerler: d } }));
        // kategori seçiliyken önce Stokta, hemen ardından o kategorinin filtre türleri (kullanıcı 15.10)
        if (oneri.length && !secili.some((s) => s.tur === 'stok')) oneri.unshift({ j: STOK, altYok: true });
      }
      acikGrup = null;
      if (!oneri.length) {   // her kategoride işe yarayan hızlı filtreler; seçili olan çıkmaz
        oneri = [
          ...(secili.some((s) => s.tur === 'stok') ? [] : [STOK]),
          ...(secili.some((s) => s.tur === 'fiyat') ? [] : [fiyatJeton(null, 2000), fiyatJeton(null, 5000)]),
        ].map((x) => ({ j: x, altYok: true }));
      }
      return oneri.length ? [{ baslik: 'Filtre ekle' }, ...oneri] : [];
    }
    // çip yokken boş kutu: keşif ekranı (son aramalar, kategoriler, markalar) gösterilir, öneri listesi gerekmez
    if (kesfet) return [];
    const out = [];
    const son = sonAramalar();
    if (son.length) out.push({ baslik: 'Son aramalar' }, ...son.map((s) => ({ son: s })));
    out.push({ baslik: 'Kategoriler' }, ...jetonlar.filter((j) => j.tur === 'kat' && j.c).map((j) => ({ j })));
    return out;
  }

  /* ================= çizim ================= */
  function guncelle() {
    if (!document.activeElement || document.activeElement !== input) return;
    urunVurgusunuKaldir();
    const { parca, bulunan } = aday();
    sonParca = parca;
    if (input.value.trim()) acikGrup = null;
    // en üstte hep "ara" satırı (Raycast gibi): Enter arama sayfasına gider, Tab ilk öneriyi çip yapar
    const ara = input.value.trim() || secili.length ? [{ ara: true }] : [];
    const oneriler = bulunan.map((b) => ({ j: b.j, etiketle: b.etiketle }));
    const kartlik = (s) => s.j.tur === 'mrk' || s.j.tur === 'kat';   // marka / kategori: logolu büyük kart, diğerleri hap
    // grup sırası en iyi eşleşmeye göre: o kart ise kartlar üstte, değilse haplar (Tab hep en iyi eşleşmeye gider)
    const kartlar = oneriler.filter(kartlik).slice(0, 3), haplar = oneriler.filter((s) => !kartlik(s));
    const gruplu = oneriler[0] && kartlik(oneriler[0]) ? [...kartlar, ...haplar] : [...haplar, ...kartlar];
    // kutu boşken seçili marka / kategori: logolu kart en üstte, tıklayınca / Enter'da koleksiyon sayfası (kullanıcı isteği)
    const secimKartlari = input.value.trim() ? [] : secili.filter((x) => (x.tur === 'mrk' || x.tur === 'kat') && kesfetGorseli(x.id)?.url).slice(0, 1).map((x) => ({ secim: x }));   // marka + kategori varken tek kart (marka önce)
    satirlar = [...secimKartlari, ...ara, ...(bulunan.length ? gruplu : (!input.value.trim() ? bosOneriler() : []))];
    imlec = satirlar.findIndex((s) => !s.baslik);
    // birden fazla çip varken Enter koleksiyon kartına değil "Bu filtrelerle tüm ürünleri gör"e gitsin: koleksiyon sayfası diğer
    // filtreleri (fiyat, marka…) taşımıyor (kullanıcı 14.10: Klavye + 5.000 TL → /collections/klavyeler, fiyat kayboluyordu)
    if (satirlar[imlec]?.secim && secili.length > 1) imlec = satirlar.findIndex((s) => s.ara);
    okKullanildi = false;
    cizListe();
    cizGolge(bulunan.length ? satirlar.find((s) => s.j) : null);
  }

  function kalan(etiket, parca) {
    const hedef = norm(parca);
    for (let i = 1; i <= etiket.length; i++) if (norm(etiket.slice(0, i)) === hedef) return etiket.slice(i);
    return null;
  }

  let olcu;
  function yaziGenisligi(metin) {
    olcu ??= document.createElement('canvas').getContext('2d');
    const s = getComputedStyle(input);
    olcu.font = `${s.fontStyle} ${s.fontWeight} ${s.fontSize} ${s.fontFamily}`;
    return olcu.measureText(metin).width;
  }

  golge.addEventListener('mousedown', (e) => { e.preventDefault(); if (tabHedefi() >= 0) sec(tabHedefi()); });
  function cizGolge(ilk) {
    golge.textContent = '';
    if (!ilk?.j) return;
    const s = getComputedStyle(input);
    const x = input.offsetLeft + parseFloat(s.paddingLeft) + yaziGenisligi(input.value) - input.scrollLeft;
    if (x > input.offsetLeft + input.clientWidth - 40) return;   // kutu taşacaksa gölge gösterilmez, liste yeterli
    Object.assign(golge.style, { left: `${x}px`, top: `${input.offsetTop}px`, height: `${input.offsetHeight}px`, font: s.font });
    const devam = ilk.etiketle ? kalan(ilk.j.l, sonParca) : null;
    const span = document.createElement('span');
    span.className = devam ? 'spotlight-golge__metin' : 'spotlight-golge__hedef';
    span.textContent = devam ?? `→ ${ilk.j.l}`;
    // "Tab" rozeti sadece burada (kullanıcı 13.10: tamamlamak için Tab'a basılacağı bilinmiyor); gölgeye tıklamak / dokunmak da tamamlar
    const tus = document.createElement('kbd');
    tus.className = 'spotlight-tus';
    tus.textContent = 'Tab';
    golge.append(span, tus);
  }

  function cizListe() {
    liste.innerHTML = '';
    const goster = satirlar.some((s) => !s.baslik);
    liste.hidden = !goster;
    input.setAttribute('aria-expanded', String(goster));
    // çip önerileri alt alta değil tek satırda hap (yer kaplamasın, ürünlere alan kalsın); başlık satırın başında
    let hapSatiri = null;
    let kartSatiri = null;
    let baslikli = false;
    const hapSatiriAc = (baslik, geri) => {
      hapSatiri = document.createElement('div');
      hapSatiri.className = 'spotlight-hap-satiri';
      hapSatiri.setAttribute('role', 'presentation');
      const h = document.createElement(geri ? 'button' : 'span');
      h.className = 'spotlight-baslik';
      h.textContent = baslik;
      if (geri) {   // açık filtre türünün adı: tıklayınca türlere geri döner
        h.type = 'button';
        h.classList.add('spotlight-baslik--geri');
        h.setAttribute('aria-label', `${baslik}: filtre türlerine dön`);
        h.title = 'Filtre türlerine dön';
        h.innerHTML = `${svg('geri')}<span></span>`;   // geri oku + tür adı: düğme olduğu anlaşılsın (kullanıcı 14.10)
        h.querySelector('span').textContent = baslik;
        h.addEventListener('mousedown', (e) => { e.preventDefault(); if (document.activeElement !== input) input.focus({ preventScroll: true }); acikGrup = null; guncelle(); });
      }
      hapSatiri.append(h);
      liste.append(hapSatiri);
    };
    satirlar.forEach((s, i) => {
      if (s.baslik) {
        if (satirlar[i + 1]?.j || satirlar[i + 1]?.grup) { hapSatiriAc(s.baslik, s.geri); baslikli = true; return; }   // başlığın altı çipse: hap satırının etiketi
        hapSatiri = null;
        const h = document.createElement('div');
        h.className = 'spotlight-baslik';
        h.setAttribute('role', 'presentation');
        h.textContent = s.baslik;
        liste.append(h);
        return;
      }
      const kart = (s.j && (s.j.tur === 'mrk' || s.j.tur === 'kat') && !baslikli) || s.secim;   // başlıklı listede (boş kutu) hap kalır
      if (kart && !kartSatiri) {
        kartSatiri = document.createElement('div');
        kartSatiri.className = 'spotlight-kart-satiri';
        kartSatiri.setAttribute('role', 'presentation');
        liste.append(kartSatiri);
      }
      const hap = (s.j && !kart) || s.grup;
      if (hap && !hapSatiri) hapSatiriAc('Filtre ekle');
      if (!s.j && !s.secim && !s.grup) { hapSatiri = null; kartSatiri = null; baslikli = false; }
      const el = document.createElement('div');
      el.className = kart ? `spotlight-oneri spotlight-oneri--kart${s.secim ? ' spotlight-oneri--secim' : ''}` : hap ? `spotlight-oneri spotlight-oneri--hap${s.grup ? ' spotlight-oneri--grup' : ''}` : 'spotlight-oneri';
      el.id = `spotlight-oneri-${i}`;
      el.setAttribute('role', 'option');
      el.setAttribute('aria-selected', String(i === imlec));
      if (s.ara) {
        const yazi = input.value.trim();
        const baglam = secili.map((j) => j.l).join(' · ');
        el.classList.add('spotlight-oneri--ara');
        el.innerHTML = `${kutucuk(svg('ara'))}<span class="spotlight-oneri__ad"></span><span class="spotlight-oneri__alt"></span>`;
        el.querySelector('.spotlight-oneri__ad').textContent = yazi ? `“${yazi}” için ara` : 'Bu filtrelerle tüm ürünleri gör';
        el.querySelector('.spotlight-oneri__alt').textContent = baglam ? (yazi ? `${baglam} içinde` : baglam) : 'Tüm ürünlerde';
      } else if (s.son) {
        const ozet = [s.son.q, ...s.son.ids.map((id) => jetonBul(id)?.l || (id.startsWith('fiyat:') ? 'Fiyat' : '')).filter(Boolean)].filter(Boolean).join(' · ');
        el.innerHTML = `${kutucuk(svg('clock'))}<span class="spotlight-oneri__ad"></span>`;
        el.querySelector('.spotlight-oneri__ad').textContent = ozet;
      } else if (kart) {
        // ana sayfadaki arama gibi: logo / kategori görseli + ad + ürün sayısı; ok marka/kategori sayfasına gider.
        // Öneri kartı (Tab: filtre ekler) ile seçili çipin kartı (↵: koleksiyona gider) AYNI tasarım
        const x = s.j || s.secim;
        const g = kesfetGorseli(x.id);
        el.innerHTML = `<span class="spotlight-kart__gorsel">${g?.src ? '<img alt="" loading="lazy">' : ikonHtml(x)}</span><span class="spotlight-kart__metin"><span class="spotlight-oneri__ad"></span><span class="spotlight-oneri__alt"></span></span>${g?.url ? `<a class="spotlight-kart__git" aria-label="${esc(x.l)} ürünlerini gör">${svg('ok')}</a>` : ''}`;
        if (g?.src) el.querySelector('img').src = g.src;
        if (g?.url) el.querySelector('.spotlight-kart__git').href = aramaAdresi([x]);
        el.querySelector('.spotlight-oneri__ad').textContent = x.l;
        el.querySelector('.spotlight-oneri__alt').textContent = x.n ? `${x.alt} · ${x.n} ürün` : x.alt;
      } else if (s.grup) {   // filtre türü: ad + kaç seçeneği olduğu; sayıyı sayilariYaz() doldurur
        el.innerHTML = `${kutucuk(svg(s.grup.ikon))}<span class="spotlight-oneri__ad"></span><span class="spotlight-oneri__alt"></span>`;
        el.querySelector('.spotlight-oneri__ad').textContent = s.grup.ad;
      } else {
        el.innerHTML = `${ikonHtml(s.j)}<span class="spotlight-oneri__ad"></span><span class="spotlight-oneri__alt"></span>`;
        el.querySelector('.spotlight-oneri__ad').textContent = s.j.l;
        // kategori kalır: iki "Kablolu" (klavye / mouse) ayırt edilsin
        el.querySelector('.spotlight-oneri__alt').textContent = s.altYok || s.sayi ? '' : s.alt || (s.j.alt2 ? `${s.j.alt1} · ${s.j.alt2}` : s.j.alt);
      }
      // ad + alt yazı aynı taban çizgisinde (16px ve 14px kutular ortalanınca küçük yazı yukarıda duruyordu)
      if (!kart) {
        const ad = el.querySelector(':scope > .spotlight-oneri__ad'), alt = el.querySelector(':scope > .spotlight-oneri__alt');
        if (ad && alt) { const m = document.createElement('span'); m.className = 'spotlight-oneri__metin'; ad.before(m); m.append(ad, alt); }
      }
      el.addEventListener('mousedown', (e) => {
        e.preventDefault();   // input odağı kaybolmasın
        if (e.target.closest('a.spotlight-kart__git')) return;   // ok: bağlantı kendi açılır (click)
        // boş yere tıklanıp odak gittiyse geri al: guncelle() odak kutuda değilken çizmiyor (filtre türü hapları tepkisiz kalıyordu, 14.10)
        if (document.activeElement !== input) input.focus({ preventScroll: true });
        sec(i);
      });
      el.addEventListener('mousemove', () => { if (imlec !== i) { imlec = i; okKullanildi = true; vurgula(); } });
      (kart ? kartSatiri : hap && hapSatiri ? hapSatiri : liste).append(el);
    });
    sayilariYaz();
    vurgula();
  }

  /* Marka logosu / kategori görseli: keşif ekranındaki (snippets/spotlight-kesfet.liquid) logolardan ve kartlardan.
     Tek çipli öğe öncelikli (Hall Effect Klavye kartı "kat:Klavye"yi ezmesin). */
  let gorselHaritasi = null;
  function kesfetGorseli(id) {
    if (!gorselHaritasi) {
      gorselHaritasi = new Map();
      const tekli = [], cok = [];
      kesfet?.querySelectorAll('.spk-marka[data-spk-jeton], .spk-kart[data-spk-jeton]').forEach((el) => {
        let ids = [];
        try { ids = JSON.parse(el.dataset.spkJeton); } catch { /* bozuk */ }
        (ids.length === 1 ? tekli : cok).push([ids[0], el]);
      });
      for (const [k, el] of [...tekli, ...cok]) {
        if (!k || gorselHaritasi.has(k)) continue;
        gorselHaritasi.set(k, { src: el.querySelector('img')?.getAttribute('src'), url: el.dataset.spkUrl });
      }
    }
    return gorselHaritasi.get(id);
  }

  // Tab / → hedefi: "ara" satırı seçiliyken ilk öneri, değilse seçili satır
  const tabHedefi = () => (satirlar[imlec]?.ara || satirlar[imlec]?.secim ? satirlar.findIndex((s) => (s.j || s.son || s.grup) && !secilemez(s)) : imlec);

  function vurgula() {
    // tuş ipuçları (Tab / ↵ rozetleri) kullanıcı isteğiyle kaldırıldı; tuşlar aynen çalışır
    liste.querySelectorAll('.spotlight-oneri').forEach((el) => {
      const i = Number(el.id.slice('spotlight-oneri-'.length));
      el.setAttribute('aria-selected', String(i === imlec));
      if (i === imlec) el.scrollIntoView({ block: 'nearest' });
    });
    input.setAttribute('aria-activedescendant', imlec >= 0 && !liste.hidden ? `spotlight-oneri-${imlec}` : '');
  }

  function imleciOynat(yon) {
    const idx = satirlar.map((s, i) => (s.baslik ? -1 : i)).filter((i) => i >= 0);
    const k = idx.indexOf(imlec);
    if (yon > 0 && k === idx.length - 1) return urunlereGec();   // listenin sonundan ürün sonuçlarına in
    if (yon < 0 && k <= 0) return false;
    imlec = idx[(k + yon + idx.length) % idx.length];
    okKullanildi = true;
    vurgula();
    return true;
  }

  /* ================= çip ekleme / çıkarma ================= */
  function sec(i = imlec) {
    const s = satirlar[i];
    if (!s) return false;
    if (s.ara) { form.requestSubmit(); return true; }
    if (s.secim) { form.requestSubmit(); return true; }   // 15.10: koleksiyona değil arama sayfasına (filtreler orada var)
    if (s.son) return sonAramayiYukle(s.son);
    if (secilemez(s)) return false;   // bu seçimle ürünü olmayan değer
    if (s.grup) { acikGrup = s.grup.p; guncelle(); return true; }
    return ekle(s.j, true);
  }

  function ekle(j, parcayiSil) {
    if (secili.length >= MAKS_CIP) { bildir(`En fazla ${MAKS_CIP} filtre eklenebilir`); return false; }
    if (parcayiSil && sonParca) {
      input.value = input.value.slice(0, input.value.length - sonParca.length).trimEnd();
      if (input.value) input.value += ' ';
    }
    return jetonlariEkle([j]);
  }

  /* Bir ya da birden çok çip (keşif kartı: Klavye + Manyetik gibi) tek seferde eklenir, arama bir kez yenilenir. */
  function jetonlariEkle(js) {
    js = js.filter(Boolean);
    if (!js.length) return false;
    for (const j of js) {
      if (secili.length >= MAKS_CIP) break;
      // tek fiyat, tek stok, tek kategori: yenisi eskisinin yerine geçer
      if (['fiyat', 'stok', 'kat'].includes(j.tur)) secili = secili.filter((s) => s.tur !== j.tur);
      if (!secili.some((s) => s.id === j.id)) secili.push(j);
    }
    // kategori değiştiyse uyumsuz filtre çiplerini bırak
    const kilit = kilitKategori();
    secili = secili.filter((s) => s.tur !== 'deg' || !kilit || s.c === kilit);
    cizCipler();
    bildir(`Filtre eklendi: ${js.map((j) => j.l).join(', ')}`);
    yenile();
    return true;
  }

  const idDenJeton = (id) => {
    if (id.startsWith('fiyat:')) { const [a, b] = id.slice(6).split('-'); return fiyatJeton(a ? Number(a) : null, b ? Number(b) : null); }
    return jetonBul(id);
  };

  function kaldir(j) {
    secili = secili.filter((s) => s !== j);
    cizCipler();
    bildir(`Filtre kaldırıldı: ${j.l}`);
    yenile();
  }

  function parametreler(j) {
    if (j.tur === 'deg') return [[j.p, j.v]];
    if (j.tur === 'stok') return [['filter.v.availability', '1']];
    if (j.tur === 'fiyat') return [...(j.min != null ? [['filter.v.price.gte', String(j.min)]] : []), ...(j.max != null ? [['filter.v.price.lte', String(j.max)]] : [])];
    if (j.tur === 'mrk' && D.vendorFiltre) return [['filter.p.vendor', j.l]];
    if (j.tur === 'kat' && D.tipFiltre) return j.tip.map((t) => ['filter.p.product_type', t]);
    return [];
  }

  /* URL filtresi kayıtlı değilse marka/kategori arama sözdizimine eklenir; aynı türdekiler OR ile */
  function sozdizimi() {
    const parca = [];
    const markalar = D.vendorFiltre ? [] : secili.filter((j) => j.tur === 'mrk').map((j) => `vendor:"${j.l}"`);
    if (markalar.length) parca.push(markalar.length > 1 ? `(${markalar.join(' OR ')})` : markalar[0]);
    const kat = D.tipFiltre ? null : secili.find((j) => j.tur === 'kat');
    if (kat) {
      const tipler = kat.tip.map((t) => `product_type:"${t}"`);
      parca.push(tipler.length > 1 ? `(${tipler.join(' OR ')})` : tipler[0]);
    }
    return parca.join(' ');
  }

  function cizCipler() {
    acikGrup = null;   // çipler değişince satır filtre türlerine döner
    cipler.innerHTML = '';
    gizli.innerHTML = '';
    for (const j of secili) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = `spotlight-cip spotlight-cip--${j.tur}`;
      b.setAttribute('aria-label', `Filtreyi kaldır: ${j.l}`);
      b.innerHTML = `${ikonHtml(j)}<span class="spotlight-cip__ad"></span><svg class="spotlight-cip__x" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2"><path d="M7 7l10 10M17 7L7 17"/></svg>`;
      b.querySelector('.spotlight-cip__ad').textContent = j.l;
      b.title = j.alt;
      b.addEventListener('click', () => { kaldir(j); input.focus(); });
      // klavye: ⌫ / Delete çipi siler (odak bir öncekine), ← → çipler arasında, Esc yazıya döner
      b.addEventListener('keydown', (e) => {
        const tum = [...cipler.querySelectorAll('.spotlight-cip')];
        const i = tum.indexOf(b);
        if (e.key === 'Backspace' || e.key === 'Delete') {
          e.preventDefault();
          kaldir(j);
          requestAnimationFrame(() => cipler.querySelectorAll('.spotlight-cip')[i - 1]?.focus());
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          tum[i - 1]?.focus();
        } else if (e.key === 'ArrowRight' || e.key === 'Escape') {
          e.preventDefault();
          if (e.key === 'ArrowRight' && tum[i + 1]) tum[i + 1].focus();
          else { input.focus(); input.setSelectionRange(0, 0); }
        }
      });
      cipler.append(b);
      for (const [ad, deger] of parametreler(j)) {
        const h = document.createElement('input');
        h.type = 'hidden';
        h.name = ad;
        h.value = deger;
        gizli.append(h);
      }
    }
    kutu.classList.toggle('spotlight--cipli', secili.length > 0);
  }

  /* Tema aramasını yeniden tetikler (theme.js input'u debounce ile dinliyor). */
  function yenile() {
    satirlar = [];
    cizListe();
    golge.textContent = '';
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.focus();
    input.setSelectionRange(input.value.length, input.value.length);
    requestAnimationFrame(guncelle);
  }

  let duyuruZaman;
  function bildir(metin) {
    duyuru.textContent = metin;
    clearTimeout(duyuruZaman);
    duyuruZaman = setTimeout(() => { duyuru.textContent = ''; }, 2000);
  }

  /* ================= son aramalar (sadece bu tarayıcıda) ================= */
  function sonAramalar() {
    try { return JSON.parse(localStorage.getItem(SON_ANAHTAR) || '[]').filter((s) => s.q || s.ids?.length).slice(0, 10); } catch { return []; }
  }
  function sonAramayaEkle() {
    const kayit = { q: input.value.trim() === '*' ? '' : input.value.trim(), ids: secili.map((j) => j.id), f: secili.filter((j) => j.tur === 'fiyat').map((j) => [j.min, j.max]) };
    if (!kayit.q && !kayit.ids.length) return;
    try {
      const anahtar = JSON.stringify([kayit.q, kayit.ids]);
      const eski = sonAramalar().filter((s) => JSON.stringify([s.q, s.ids]) !== anahtar);
      localStorage.setItem(SON_ANAHTAR, JSON.stringify([kayit, ...eski].slice(0, 10)));
    } catch { /* gizli sekme / kapalı depolama: önemli değil */ }
    cizSonHaplar();
  }
  function sonAramayiYukle(s) {
    secili = s.ids.map(idDenJeton).filter(Boolean);
    input.value = s.q || '';
    cizCipler();
    yenile();
    return true;
  }

  /* ================= ürün sonuçlarında klavye gezintisi ================= */
  const urunLinkleri = () => [...form.querySelectorAll('[slot="results"] [slot="content"]')].slice(0, 1)
    .flatMap((icerik) => [...icerik.querySelectorAll('a[href*="/products/"]')])
    .filter((a) => !a.closest('.spotlight-detay'))   // önizleme panelindeki bağlantılar gezintiye girmesin
    .filter((a, i, l) => l.findIndex((x) => x.href === a.href) === i && a.offsetParent);
  function urunlereGec() {
    const l = urunLinkleri();
    if (!l.length) return false;
    urunImlec = 0;
    urunVurgula(l);
    return true;
  }
  function urunVurgula(l = urunLinkleri()) {
    l.forEach((a, i) => a.classList.toggle('spotlight-urun--aktif', i === urunImlec));
    l[urunImlec]?.scrollIntoView({ block: 'nearest' });
    if (l[urunImlec]) onizle(l[urunImlec]);
    imlec = -1;
    vurgula();
  }
  function urunVurgusunuKaldir() {
    if (urunImlec < 0) return;
    form.querySelectorAll('.spotlight-urun--aktif').forEach((a) => a.classList.remove('spotlight-urun--aktif'));
    urunImlec = -1;
  }

  /* ================= olaylar ================= */
  input.addEventListener('input', (e) => { if (e.isTrusted) guncelle(); });
  input.addEventListener('focus', guncelle);
  input.addEventListener('click', guncelle);
  // Odak kutudan çıkınca (önizlemede varyanta, sekmeye tıklama…) liste KALIR: "… için ara" satırı gidince panel
  // kısalıp zıplıyordu. Sadece Tab tamamlama gölgesi silinir; liste Esc / temizle / panel kapanınca gider.
  input.addEventListener('blur', () => setTimeout(() => {
    if (document.activeElement !== input) golge.textContent = '';
  }, 150));

  input.addEventListener('keydown', (e) => {
    if (e.isComposing) return;
    const acik = !liste.hidden && satirlar.some((s) => !s.baslik);

    if (urunImlec >= 0) {   // ürün sonuçlarında geziniyor
      const l = urunLinkleri();
      if (e.key === 'ArrowDown') { e.preventDefault(); urunImlec = Math.min(urunImlec + 1, l.length - 1); urunVurgula(l); return; }
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (urunImlec === 0) { urunVurgusunuKaldir(); if (acik) { imlec = satirlar.map((s, i) => (s.baslik ? -1 : i)).filter((i) => i >= 0).pop(); vurgula(); } return; }
        urunImlec--; urunVurgula(l); return;
      }
      if (e.key === 'Enter') { e.preventDefault(); sonAramayaEkle(); window.location.href = l[urunImlec].href; return; }
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); urunVurgusunuKaldir(); return; }
      urunVurgusunuKaldir();
    }

    if (acik && e.key === 'Tab' && !e.shiftKey && tabHedefi() >= 0) { e.preventDefault(); sec(tabHedefi()); return; }
    if (acik && e.key === 'ArrowRight' && tabHedefi() >= 0 && input.value && input.selectionStart === input.value.length) { e.preventDefault(); sec(tabHedefi()); return; }
    if (e.key === 'ArrowDown') { e.preventDefault(); if (acik ? imleciOynat(1) : urunlereGec()) return; return; }
    if (acik && e.key === 'ArrowUp') { e.preventDefault(); imleciOynat(-1); return; }
    if (acik && e.key === 'Enter' && imlec >= 0 && (okKullanildi || satirlar[imlec]?.secim)) { e.preventDefault(); sec(); return; }
    if (acik && e.key === 'Escape' && acikGrup) { e.preventDefault(); e.stopPropagation(); acikGrup = null; guncelle(); return; }   // önce açık filtre türü kapanır
    if (acik && e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); satirlar = []; cizListe(); golge.textContent = ''; return; }
    // ⌫: kutu boşsa (ya da imleç en baştaysa) son çip silinir — macOS Spotlight gibi
    if (e.key === 'Backspace' && secili.length && (!input.value || (input.selectionStart === 0 && input.selectionEnd === 0))) {
      e.preventDefault();
      kaldir(secili[secili.length - 1]);
      return;
    }
    // ←: imleç en baştaysa son çipe geçilir (oradan ⌫ / Delete ile silinir)
    if (e.key === 'ArrowLeft' && secili.length && input.selectionStart === 0 && input.selectionEnd === 0) {
      e.preventDefault();
      cipler.lastElementChild?.focus();
    }
  });

  // Verilen çiplerin arama sayfası adresi (15.10: kart / ok / seçim kartı koleksiyon yerine buraya gider)
  function aramaAdresi(js) {
    const p = new URLSearchParams([...new FormData(form)].filter(([k]) => k !== 'q' && !k.startsWith('filter.')));
    p.set('q', js.filter((j) => j.tur === 'ozl').map((j) => j.metin).join(' ') || '*');
    js.flatMap(parametreler).forEach(([k, v]) => p.append(k, v));
    if (!js.some((j) => j.tur === 'stok')) p.set('filter.v.availability', '1');   // ürün adı değil → stoktakiler
    return `${form.action}?${p}`;
  }

  // Sonuç sayfasındaki kutu boşken "Ara": bütün ürünler filtrelerle (q=*; başlıkta "N ürün", kutuda * görünmez — main-search.liquid)
  // kutuya "*" yazılmaz (gönderilene kadar görünüyordu, kullanıcı 15.10): adres elle kurulur
  // tükenmiş kuralı sonuç sayfasında da (kullanıcı 15.10): ürün adıyla aranmıyorsa sayfa "Yalnızca stoktakiler" açık gelir
  document.querySelectorAll('form.main-search-form').forEach((f) => f.addEventListener('submit', (e) => {
    const q = f.querySelector('input[name="q"]');
    const yazi = q?.value.trim() || '';
    if (!q || (yazi && !kategoriAramasi(yazi))) return;
    e.preventDefault();
    const p = new URLSearchParams(new FormData(f));
    p.set('q', yazi || '*');
    p.set('filter.v.availability', '1');
    window.location.href = `${f.action}?${p}`;
  }));
  if (location.pathname.endsWith('/search') && new URLSearchParams(location.search).has('q') && !new URLSearchParams(location.search).get('q').trim()) {
    const u = new URL(location.href); u.searchParams.set('q', '*'); location.replace(u);   // eski boş "?q=" bağlantıları
  }

  /* Gönderim: arama sözdizimi (gerekirse) yazının önüne eklenir; yazı yoksa q=* */
  form.addEventListener('submit', (e) => {
    if (e.target !== form) return;   // panel içindeki başka bir form arama sayılmasın
    sonAramayaEkle();
    const yazi = input.value.trim();
    const { q, stok } = window.spotlight.istek(yazi);
    if (!q || (q === yazi && !stok)) return;   // ürün adıyla düz yazı: form kendi gönderir (çipler gizli filter.* alanlarında)
    // sadece çip (q = *), sözdizimi eklenmiş sorgu ya da kategori araması: kutuya "*" yazmadan doğrudan sonuç sayfasına
    e.preventDefault();
    e.stopImmediatePropagation();
    const p = new URLSearchParams(new FormData(form));
    p.set('q', q);
    if (stok) p.set('filter.v.availability', '1');   // ürün adıyla aranmıyorsa sayfa stoktakilerle açılır (düğmeyle kapatılabilir)
    window.location.href = `${form.action}?${p}`;
  }, true);

  form.addEventListener('reset', () => {
    secili = [];
    cizCipler();
    satirlar = [];
    cizListe();
    golge.textContent = '';
    urunVurgusunuKaldir();
    // form sıfırlanınca input olayı tetiklenmiyor: temaya "kutu boşaldı" de ki sonuçları kapatıp keşif ekranını göstersin
    requestAnimationFrame(() => input.dispatchEvent(new Event('input', { bubbles: true })));
  });

  /* "Bunu mu demek istediniz?": hiçbir ürün kelimesinin başına uymayan sözcük, en yakın dizin kelimesine çevrilir
     (6+ harfte 2, daha kısada 1 harf hata; eşitlikte sık geçen kelime — dizin sıklığa göre sıralı; sadece harfli kelimeler) */
  const sozluk = [...new Set([...(D.sozluk || []), ...jetonlar.flatMap((j) => j.t.flatMap((t) => t.split(' ')))])].filter((w) => w.length >= 3);
  function uzaklik(a, b) {   // Levenshtein + yan yana harf yer değiştirmesi (wriath → wraith = 1)
    const d = Array.from({ length: a.length + 1 }, (_, i) => [i, ...Array(b.length).fill(0)]);
    for (let j = 1; j <= b.length; j++) d[0][j] = j;
    for (let i = 1; i <= a.length; i++) for (let j = 1; j <= b.length; j++) {
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
    }
    return d[a.length][b.length];
  }
  function duzeltme(yazi) {
    let degisti = false;
    const out = norm(yazi).split(/[^a-z0-9%]+/).filter(Boolean).map((w) => {
      // rakamlı kelime model kodudur (w75, x2v2): düzeltilmez, düzeltme adayı da olmaz
      if (w.length < 3 || /[^a-z]/.test(w) || sozluk.some((s) => s.startsWith(w))) return w;
      const sinir = w.length >= 6 ? 2 : 1;
      let en = null, enU = sinir + 1;
      for (const s of sozluk) {
        if (Math.abs(s.length - w.length) > sinir || /[^a-z]/.test(s)) continue;
        const u = uzaklik(w, s);
        if (u < enU) { en = s; enU = u; }
      }
      if (!en) return w;
      degisti = true;
      return en;
    });
    return degisti ? out.join(' ') : '';
  }

  // tema düzenleyicideki "Popüler aramalar" (satır satır) doluysa o, değilse snippet'teki varsayılan liste
  const populerAramalar = () => {
    const ayar = (kesfet?.dataset.spkPopulerAyar || '').split(/\r?\n/).map((t) => t.trim()).filter(Boolean);
    if (ayar.length) return ayar;
    try { return JSON.parse(kesfet?.dataset.spkPopuler || '[]'); } catch { return []; }
  };

  /* Sonuç yoksa: ne arandığı (Türkçe, tema çevirisinden bağımsız) + çıkış yolları — son filtreyi kaldır, popüler aramalar */
  const sonucAlani = form.querySelector('predictive-search');
  if (sonucAlani) {
    new MutationObserver(() => {
      const bos = sonucAlani.querySelector('[slot="results"] .empty-state');
      if (!bos || bos.dataset.spotlight) return;
      bos.dataset.spotlight = '1';
      bos.classList.add('spotlight-sonucsuz');
      const yazi = input.value.trim();
      bos.innerHTML = `${kutucuk(svg('ara'))}<p class="spotlight-sonucsuz__baslik"></p><p class="spotlight-sonucsuz__alt"></p><div class="spotlight-sonucsuz__yollar"></div>`;
      bos.querySelector('.spotlight-sonucsuz__baslik').textContent = yazi ? `“${yazi}” için sonuç bulunamadı` : 'Bu filtrelerle sonuç bulunamadı';
      const oneri = yazi && duzeltme(yazi);
      if (oneri) {
        const p = document.createElement('p');
        p.className = 'spotlight-duzelt';
        p.innerHTML = 'Bunu mu demek istediniz: <button type="button"></button>?';
        p.querySelector('button').textContent = oneri;
        p.querySelector('button').addEventListener('click', () => { input.value = oneri; yenile(); });
        bos.querySelector('.spotlight-sonucsuz__baslik').after(p);
      }
      bos.querySelector('.spotlight-sonucsuz__alt').textContent = secili.length ? 'Bir filtreyi kaldırmayı ya da daha genel bir kelime yazmayı dene.' : 'Yazımı kontrol et ya da daha genel bir kelime dene.';
      const yollar = bos.querySelector('.spotlight-sonucsuz__yollar');
      if (secili.length) {
        const son = secili[secili.length - 1];
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'spotlight-bos';
        b.innerHTML = `${svg('kapat')}<span></span>`;
        b.querySelector('span').textContent = `“${son.l}” filtresini kaldır`;
        b.addEventListener('click', () => kaldir(son));
        yollar.append(b);
      }
      populerAramalar().slice(0, secili.length ? 3 : 5).forEach((t) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'spk-son-hap spk-son-hap--populer';
        b.innerHTML = `${svg('trend')}<span></span>`;
        b.querySelector('span').textContent = t;
        b.addEventListener('click', () => { secili = []; cizCipler(); input.value = t; yenile(); });
        yollar.append(b);
      });
    }).observe(sonucAlani, { childList: true, subtree: true });
  }

  /* Bölünmüş önizleme (bölüm ayarı "Ürün önizleme paneli", masaüstü): ürün listesi solda, seçili ürünün detayı sağda.
     Detay her sonucun içindeki gizli <template class="spotlight-detay-veri">'den (snippets/spotlight-urun-ek.liquid). */
  const onizlemeAcik = () => drawer?.hasAttribute('data-spotlight-onizleme') && matchMedia('(min-width: 1000px)').matches;
  let onizlenen = null;
  function onizle(a) {
    const aside = a?.closest('.spotlight-bolunmus')?.querySelector(':scope > .spotlight-detay');
    const veri = a?.querySelector('template.spotlight-detay-veri');
    if (!aside || !veri || onizlenen === a) return;
    onizlenen = a;
    aside.replaceChildren(veri.content.cloneNode(true));
    aside.scrollTop = 0;   // yeni ürün en üstten
    // varyant görselleri önceden yüklenir: seçeneğe tıklayınca görsel yazılarla AYNI ANDA değişsin (indirme beklemesin)
    try {
      const gorseller = new Set(JSON.parse(aside.querySelector('script.spotlight-varyantlar')?.textContent || '[]').map((v) => v.g).filter(Boolean));
      [...gorseller].slice(0, 12).forEach((u) => { new Image().src = u; });
    } catch { /* varyant yok */ }
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
      aside.animate([{ opacity: 0, transform: 'translateY(6px)' }, { opacity: 1, transform: 'none' }], { duration: 200, easing: 'cubic-bezier(.2, .7, .2, 1)' });
    }
  }
  /* Önizlemede seçenek değeri → o değerlerle eşleşen varyant (yoksa o değerin ilk, tercihen stoktaki varyantı):
     görsel, fiyat, stok ve görsel / ad bağlantısı (?variant=) güncellenir — ürün sayfasındaki seçici gibi */
  function varyantSec(aside, buton) {
    let varyantlar;
    try { varyantlar = JSON.parse(aside.querySelector('script.spotlight-varyantlar')?.textContent || '[]'); } catch { return; }
    const sira = Number(buton.dataset.spkSec);
    const secim = [...aside.querySelectorAll('.spotlight-detay__secenekler .spotlight-secenek')].map((g) => g.querySelector('[aria-pressed="true"]')?.dataset.deger);
    secim[sira] = buton.dataset.deger;
    const v = varyantlar.find((x) => x.o.every((d, i) => d === secim[i]))
      || varyantlar.filter((x) => x.o[sira] === secim[sira]).sort((a, b) => b.s - a.s)[0];
    if (!v) return;
    // seçili düğmeler + stok durumu seçime göre (ürün sayfası gibi): bir değer, diğer seçimler sabitken stokta
    // varyantı varsa açık, yoksa soluk + üstü çizili (A9 Air seçilince bütün renkler çizilir, A9 Air+ seçilince açılır)
    aside.querySelectorAll('[data-spk-sec]').forEach((b) => {
      const i = Number(b.dataset.spkSec), d = b.dataset.deger;
      b.setAttribute('aria-pressed', String(v.o[i] === d));
      b.classList.toggle('spotlight-deger--yok', !varyantlar.some((x) => x.s && x.o[i] === d && x.o.every((o, k) => k === i || o === v.o[k])));
    });
    // başlıktaki seçili değer ("Renk: Siyah - Gri")
    aside.querySelectorAll('.spotlight-detay__secenekler .spotlight-secenek').forEach((g, i) => {
      const yer = g.querySelector('.spotlight-secenek__secili');
      if (yer && v.o[i] != null) yer.textContent = v.o[i];
    });
    // görsel: varyantın kendisi → aynı değerli başka varyant → ürün görsellerinde alt metni eşleşen
    // (Impact kuralı "…#Renk_Siyah", ya da alt metinde "siyah" geçen); hiçbiri yoksa görsel değişmez
    const deger = norm(buton.dataset.deger);
    let gorsel = v.g || varyantlar.find((x) => x.g && norm(x.o[sira] || '') === deger)?.g;
    if (!gorsel) {
      let medya = [];
      try { medya = JSON.parse(aside.querySelector('script.spotlight-medya')?.textContent || '[]').filter(Boolean); } catch { /* yok */ }
      const kural = medya.find((m) => m.a?.includes('#') && norm(m.a.split('#').pop().split('_').pop()) === deger);
      gorsel = (kural || medya.find((m) => m.a && norm(m.a).includes(deger)))?.g;
    }
    const img = aside.querySelector('.spotlight-detay__gorsel img');
    if (img && gorsel && !img.src.endsWith(gorsel.replace(/^https?:/, ''))) {
      img.removeAttribute('srcset');
      img.src = gorsel;
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) img.animate([{ opacity: .4 }, { opacity: 1 }], { duration: 140, easing: 'ease-out' });
    }
    const fiyat = aside.querySelector('.spotlight-detay__fiyat');
    if (fiyat) fiyat.innerHTML = `<price-list class="price-list price-list--lg"><sale-price class="text-lg${v.k ? ' text-on-sale' : ''}">${esc(v.f)}</sale-price>${v.k ? `<compare-at-price class="text-subdued line-through">${esc(v.k)}</compare-at-price>` : ''}</price-list>`;
    aside.querySelectorAll('.spotlight-detay__gorsel, .spotlight-detay__ad').forEach((a) => { a.href = v.u; });
    const durum = aside.querySelector('.spotlight-detay__durum');
    if (durum) durum.hidden = v.s;   // stoktaysa rozet yok, tükenmişse "Tükendi"
    const indirim = aside.querySelector('.spotlight-detay__baslik .spotlight-rozet--indirim');
    if (indirim) indirim.hidden = !v.s || !v.k;   // tükenen ya da indirimsiz varyantta indirim rozeti gizli
  }

  function onizlemeKur() {
    onizlenen = null;
    if (!onizlemeAcik()) return;
    const liste = [...form.querySelectorAll('[slot="results"] .predictive-search__tab-content')].find((l) => l.querySelector('template.spotlight-detay-veri'));
    if (!liste || liste.classList.contains('spotlight-bolunmus')) return;
    liste.classList.add('spotlight-bolunmus');
    const sol = document.createElement('div');   // sol sütun kendi içinde kayar
    sol.className = 'spotlight-bolunmus__liste';
    sol.append(...liste.children);
    const aside = document.createElement('aside');
    aside.className = 'spotlight-detay';
    aside.setAttribute('aria-live', 'polite');
    aside.addEventListener('mousedown', (e) => { if (e.target.closest('[data-spk-sec]')) e.preventDefault(); });   // imleç kutuda kalsın
    aside.addEventListener('click', (e) => { const b = e.target.closest('[data-spk-sec]'); if (b) varyantSec(aside, b); });
    liste.append(sol, aside);
    liste.addEventListener('mouseover', (e) => { const a = e.target.closest('.predictive-search-result'); if (a && liste.contains(a)) onizle(a); });
    onizle(liste.querySelector('.predictive-search-result'));
  }

  /* Yükleniyor hissi: yazar yazmaz (280 ms bekleme + istek boyunca) arama satırının altında çizgi akar;
     sonuçlar gelince satırlar sırayla belirir (CSS: sp-cizgi, sp-gelis) */
  const yuva = sonucAlani?.shadowRoot?.querySelector('slot');
  if (drawer && yuva) {
    let zamanAsimi;
    const bitir = () => { clearTimeout(zamanAsimi); drawer.classList.remove('spotlight-yukleniyor'); };
    input.addEventListener('input', () => {
      if (!input.value.trim() && !secili.length) return bitir();
      drawer.classList.add('spotlight-yukleniyor');
      clearTimeout(zamanAsimi);
      zamanAsimi = setTimeout(bitir, 8000);   // istek hata verirse çizgi takılı kalmasın
    });
    new MutationObserver(() => { if (yuva.name !== 'loading') bitir(); }).observe(yuva, { attributes: true, attributeFilter: ['name'] });
    // yeni sonuç bloğu eklenince her sekmedeki satırlara sıra numarası (en fazla 10 → son satır ~350 ms'de)
    new MutationObserver(() => {
      sonucAlani.querySelectorAll(':scope > [slot="results"] .predictive-search__tab-content').forEach((liste) => {
        [...liste.children].forEach((el, i) => el.style.setProperty('--sp-sira', Math.min(i, 10)));
      });
      onizlemeKur();
    }).observe(sonucAlani, { childList: true });
  }

  /* ⌘K / Ctrl+K ve "/" her sayfadan aramayı açar */
  document.addEventListener('keydown', (e) => {
    const yaziyor = e.target.closest?.('input, textarea, select, [contenteditable=""], [contenteditable="true"]');
    const kTusu = e.key?.toLowerCase() === 'k' || e.code === 'KeyK';   // Caps Lock / klavye düzeni fark etmesin
    const kisayol = (kTusu && (e.metaKey || e.ctrlKey) && !e.altKey && !e.shiftKey) || (e.key === '/' && !yaziyor && !e.metaKey && !e.ctrlKey && !e.altKey);
    if (!kisayol) return;
    e.preventDefault();
    const drawer = document.getElementById('search-drawer');
    if (!drawer?.hasAttribute('open')) document.querySelector('[aria-controls="search-drawer"]')?.click();
    setTimeout(() => { input.focus(); input.select(); }, 60);
  });

  /* Sonuç sayfası: çipleri URL'den geri kur, kutudaki * ve sözdizimini gizle */
  function urldenKur() {
    // 15.10 (kullanıcı): panel her açılışta sıfırdan başlar — sonuç sayfasındaki filtreler artık panele çip olarak GERİ YÜKLENMEZ
    // (sayfanın kendi filtre paneli onları gösteriyor). Burada sadece sayfadaki görünen kutulardan "*" ve sözdizimi temizlenir.
    if (!/\/search\/?$/.test(location.pathname)) return;
    const q = (new URLSearchParams(location.search).get('q') || '')
      .replace(/\((?:\s*(?:vendor|product_type):"[^"]*"\s*(?:OR)?)+\)|(?:vendor|product_type):"[^"]*"/g, '').replace(/\s+/g, ' ').trim();
    // sadece görünen kutular: filtre panelinin / sıralamanın GİZLİ q alanı "*" kalmalı, yoksa "stoktakiler" gibi bir filtre q= boş
    // gönderip boş "Ara" sayfası açıyordu (kullanıcı 14.10)
    document.querySelectorAll('input[name="q"]:not([type="hidden"])').forEach((el) => { if (el !== input && /^\*$|vendor:"|product_type:"/.test(el.value)) el.value = q === '*' ? '' : q; });
  }

  /* ================= keşif ekranı (arama boşken; snippets/spotlight-kesfet.liquid) ================= */
  function cizSonHaplar() {
    const kap = kesfet?.querySelector('[data-spk-son]');
    if (!kap) return;
    kap.innerHTML = '';
    const son = sonAramalar();
    if (son.length) {
      // haplar kendi içinde yana kayar; "Tümünü sil" sağda sabit, her zaman görünür (kullanıcı 15.10, tasarım B)
      kap.innerHTML = '<div class="spk-son__kaydir"></div>';   // haplar kendi içinde yana kayar; sağda tek "Temizle" (temizleYerlestir)
      son.forEach((s, i) => {
        const hap = document.createElement('span');
        hap.className = 'spk-son-hap';
        hap.innerHTML = `${svg('clock')}<button type="button" class="spk-son-hap__ad" data-spk-son-i="${i}"></button><button type="button" class="spk-son-hap__sil" data-spk-son-sil="${i}" aria-label="Son aramalardan kaldır">${svg('kapat')}</button>`;
        hap.querySelector('.spk-son-hap__ad').textContent = [s.q, ...s.ids.map((id) => idDenJeton(id)?.l).filter(Boolean)].filter(Boolean).join(' · ');
        kap.firstChild.append(hap);
      });
    }
    // hiç arama yapılmamışsa boş kalır: "popüler aramalar" / "bu hafta çok arananlar" gerçek veri olmadığı için kaldırıldı (kullanıcı 14.10)
    temizleYerlestir();
  }

  /* Tek "Temizle" (kullanıcı 15.10): son aramaları VE son baktıklarını birlikte siler. Küçük gri yazı, en üstteki satırın sağında
     (son arama varsa o satır, yoksa "Son baktıkların" başlığı); toplam 1'den fazla öğe varken görünür (tekinin kendi × düğmesi var). */
  function temizleYerlestir() {
    if (!kesfet) return;
    kesfet.querySelectorAll('[data-spk-temizle]').forEach((b) => b.remove());
    const son = sonAramalar().length, bak = bakilanlar().slice(0, 4).length;
    if (son + bak < 2) return;
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'spk-temizle';
    b.dataset.spkTemizle = '';
    b.textContent = 'Temizle';
    b.setAttribute('aria-label', 'Son aramaları ve son baktıklarını temizle');
    const sonKap = kesfet.querySelector('[data-spk-son]');
    if (son && sonKap?.firstChild) sonKap.append(b);
    else kesfet.querySelector('.spk-bakilan__ust')?.append(b);
  }

  /* Son bakılan ürünler: ürün sayfasında og etiketlerinden kaydedilir (bu tarayıcıda, en fazla 8), keşif ekranında 4'ü */
  const BAKILAN_ANAHTAR = 'spotlight-bakilan';
  const bakilanlar = () => { try { return JSON.parse(localStorage.getItem(BAKILAN_ANAHTAR) || '[]'); } catch { return []; } };
  if (document.querySelector('meta[property="og:type"][content="product"]')) {
    const meta = (ad) => document.querySelector(`meta[property="${ad}"]`)?.content || '';
    const kayit = { u: location.pathname, t: meta('og:title'), g: meta('og:image:secure_url').replace(/width=\d+/, 'width=300'), f: meta('product:price:amount'), p: meta('product:price:currency') };
    if (kayit.t) try { localStorage.setItem(BAKILAN_ANAHTAR, JSON.stringify([kayit, ...bakilanlar().filter((b) => b.u !== kayit.u)].slice(0, 8))); } catch { /* depolama kapalı */ }
  }
  function cizBakilanlar() {
    const kap = kesfet?.querySelector('[data-spk-bakilan]');
    if (!kap) return;
    // bulunulan ürün de listede (15.10, kullanıcı: "W1'e gittim, çıkmadı" — tek ürün buysa bölüm hiç görünmüyordu)
    const l = bakilanlar().slice(0, 4);
    kap.hidden = !l.length;
    // tek ürünse kart solda menünün üstünde durur, Markalar sağda en üstten başlar (tam genişlik satırda boşluk bırakıyordu);
    // 2+ üründe tam genişlik satır (kullanıcı 14.10). Telefonda sol sütun üstte, fark etmez.
    const sol = kesfet.querySelector('.spk-sol');
    if (l.length === 1 && sol) { if (kap.parentNode !== sol) sol.prepend(kap); }
    else if (kap.parentNode !== kesfet) kesfet.querySelector('.spk-govde')?.before(kap);
    kap.classList.toggle('spk-bakilan--tek', l.length === 1);
    kap.innerHTML = l.length ? '<div class="spk-bakilan__ust"><h3 class="spk-baslik">Son baktıkların</h3></div><div class="spk-bakilan__liste"></div>' : '';
    l.forEach((b) => {
      const oge = document.createElement('div');
      oge.className = 'spk-bakilan__oge';
      const a = document.createElement('a');
      a.className = 'spk-bakilan__urun';
      a.href = b.u;
      a.innerHTML = '<span class="spk-bakilan__gorsel"></span><span class="spk-bakilan__bilgi"><span class="spk-bakilan__ad"></span><span class="spk-bakilan__fiyat"></span></span>';
      if (b.g) { const img = new Image(); img.src = b.g; img.alt = ''; img.loading = 'lazy'; a.firstChild.append(img); }
      a.querySelector('.spk-bakilan__ad').textContent = b.t;
      a.querySelector('.spk-bakilan__fiyat').textContent = b.f ? `${b.f} ${b.p === 'TRY' ? 'TL' : b.p}` : '';
      const sil = document.createElement('button');
      sil.type = 'button';
      sil.className = 'spk-bakilan__sil';
      sil.dataset.spkBakilanSil = b.u;
      sil.setAttribute('aria-label', `${b.t} — son baktıklarından kaldır`);
      sil.innerHTML = svg('kapat');
      oge.append(a, sil);
      kap.lastChild.append(oge);
    });
    temizleYerlestir();
  }

  if (kesfet) {
    cizBakilanlar();
    // Markalar şeridi: HTML'de trend markalar; ardına Markalar sekmesindeki diğerleri kopyalanır (snippet şişmesin).
    // Oklar (masaüstü) kaydırır, uçta pasif olur.
    const serit = kesfet.querySelector('[data-spk-serit]');
    if (serit) {
      const anahtar = (el) => el.dataset.spkJeton || el.getAttribute('href');
      const olan = new Set([...serit.children].map(anahtar));
      kesfet.querySelectorAll('[data-spk-panel="markalar"] .spk-marka').forEach((m) => { if (!olan.has(anahtar(m))) serit.append(m.cloneNode(true)); });
      const [sol, sag] = kesfet.querySelectorAll('[data-spk-kaydir]');
      const okGuncelle = () => {
        if (sol) sol.disabled = serit.scrollLeft < 4;
        if (sag) sag.disabled = serit.scrollLeft + serit.clientWidth > serit.scrollWidth - 4;
      };
      serit.addEventListener('scroll', okGuncelle, { passive: true });
      new ResizeObserver(okGuncelle).observe(serit);
    }
    kesfet.querySelectorAll('[data-spk-ikon]').forEach((b) => b.insertAdjacentHTML('afterbegin', svg(b.dataset.spkIkon)));
    // Trend kartının altındaki ürünler: koleksiyonun Shopify "en çok satan" sırası, stoktakiler (kullanıcı 15.10).
    // Liquid'de collections[...] sıralanamadığı için sections/spotlight-cok-satan.liquid koleksiyon adresinden sort_by ile çizilir.
    // Hız (kullanıcı 15.10: "4 ürün geç geliyor, site yavaş vibesi"):
    //  - panel açılınca ilk satır, o gelince diğer 9 satır boşta ikişer ikişer yüklenir (karta gelince hazır)
    //  - görseller fare kategori kartlarına girince / dokunmatikte kartlar ekrana gelince inmeye başlar
    //  - sonuç bu tarayıcıda 24 saat saklanır: saklanan anında gösterilir, sayfa başına bir kez arkada yenilenir
    //  - hazır olmayan satıra geçerken önceki satır en fazla 450 ms kalır, iskelet ancak o kadar gecikirse görünür
    const CS_SURE = 24 * 60 * 60 * 1000;
    const csAnahtar = (h) => `spotlight-cok-satan:${h}`;
    const csIstek = new Map();   // koleksiyon → bu sayfadaki taze istek (bir kez)
    let csGorsel = false;        // görsel ön yükleme niyeti
    const csOku = (h) => {
      try { const k = JSON.parse(localStorage.getItem(csAnahtar(h)) || 'null'); return k && Date.now() - k.t < CS_SURE ? k.h : null; } catch { return null; }
    };
    const csGetir = (h) => {
      if (!csIstek.has(h)) {
        csIstek.set(h, fetch(`${window.Shopify?.routes?.root || '/'}collections/${encodeURIComponent(h)}?sort_by=best-selling&filter.v.availability=1&section_id=spotlight-cok-satan`)
          .then((r) => { if (!r.ok) throw new Error(String(r.status)); return r.text(); })
          .then((html) => { try { localStorage.setItem(csAnahtar(h), JSON.stringify({ t: Date.now(), h: html })); } catch { /* depolama dolu / kapalı */ } return html; })
          .catch((e) => { csIstek.delete(h); throw e; }));
      }
      return csIstek.get(h);
    };
    const gorselleriIndir = (kok) => kok.querySelectorAll('.spk-urun img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
    function csCiz(kutu, html) {
      if (kutu.spkHtml === html) return;
      kutu.spkHtml = html;
      const urunler = new DOMParser().parseFromString(html, 'text/html').querySelectorAll('.spk-urun');
      kutu.querySelector('.spk-urun-izgara').replaceChildren(...urunler);
      kutu.classList.toggle('spk-urunler--bos', !urunler.length);
      if (csGorsel || !kutu.hidden) gorselleriIndir(kutu);
      // Doubly (para birimi uygulaması) sayfadaki .money fiyatlarını biçimler / çevirir; sonradan gelenler için kendi tetikleyicisi
      try { window.doublyChangeEvent?.(); } catch { /* uygulama yoksa ham biçim kalır */ }
    }
    async function cokSatanYukle(kutu) {
      const h = kutu?.dataset.spkCokSatan;
      if (!h) return;
      const sakli = kutu.spkHtml ? null : csOku(h);
      if (sakli) csCiz(kutu, sakli);
      try { csCiz(kutu, await csGetir(h)); } catch { if (!kutu.spkHtml) kutu.classList.add('spk-urunler--bos'); }
    }
    let istenen = null;
    const urunGoster = (i) => {
      istenen = i;
      const hedef = kesfet.querySelector(`[data-spk-urunler="${i}"]`);
      const goster = () => {
        if (istenen !== i) return;   // bu arada başka karta geçildi
        kesfet.querySelectorAll('[data-spk-urunler]').forEach((u) => { u.hidden = u !== hedef; });
        if (hedef) gorselleriIndir(hedef);
      };
      const yukleme = cokSatanYukle(hedef);
      if (!hedef || hedef.spkHtml) goster();
      else Promise.race([yukleme, new Promise((r) => setTimeout(r, 450))]).then(goster);
    };
    kesfet.querySelectorAll('.spk-kart[data-spk-i]').forEach((k) => {
      k.addEventListener('mouseenter', () => urunGoster(k.dataset.spkI));
      k.addEventListener('focus', () => urunGoster(k.dataset.spkI));
    });
    const gorselNiyeti = () => {
      if (csGorsel) return;
      csGorsel = true;
      kesfet.querySelectorAll('[data-spk-urunler]').forEach(gorselleriIndir);
    };
    const kartlar = kesfet.querySelector('[data-spk-panel="trend"] .spk-kartlar');
    if (kartlar) {
      kartlar.addEventListener('pointerenter', gorselNiyeti, { once: true });
      if (window.matchMedia('(hover: none)').matches && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((g) => { if (g.some((x) => x.isIntersecting)) { io.disconnect(); gorselNiyeti(); } });
        io.observe(kartlar);
      }
    }
    const bosta = (fn) => (window.requestIdleCallback ? requestIdleCallback(fn, { timeout: 1500 }) : setTimeout(fn, 200));
    async function digerleriniYukle(ilk) {
      const sira = [...kesfet.querySelectorAll('[data-spk-urunler]')].filter((u) => u !== ilk);
      const isci = async () => { for (let u = sira.shift(); u; u = sira.shift()) await cokSatanYukle(u); };
      bosta(() => { isci(); isci(); });   // ikişer ikişer
    }
    const ilkSatir = async () => {
      // tekrar gelen: saklanan her satır hemen çizilir (taze olanlar arkadan gelip değiştirir)
      kesfet.querySelectorAll('[data-spk-urunler]').forEach((u) => { const s = csOku(u.dataset.spkCokSatan); if (s) csCiz(u, s); });
      const ilk = kesfet.querySelector('[data-spk-urunler]:not([hidden])');
      await cokSatanYukle(ilk);
      digerleriniYukle(ilk);
    };
    if (drawer?.hasAttribute('open')) ilkSatir();
    else if (drawer) {
      const g = new MutationObserver(() => { if (drawer.hasAttribute('open')) { g.disconnect(); ilkSatir(); } });
      g.observe(drawer, { attributes: true, attributeFilter: ['open'] });
    }
    kesfet.addEventListener('mousedown', (e) => { if (e.target.closest('[data-spk-bakilan-sil], [data-spk-temizle]')) e.preventDefault(); });   // imleç kutuda kalsın
    kesfet.addEventListener('click', (e) => {
      if (e.target.closest('[data-spk-temizle]')) {   // son aramalar + son baktıkların birlikte
        try { localStorage.removeItem(SON_ANAHTAR); localStorage.removeItem(BAKILAN_ANAHTAR); } catch { /* depolama kapalı */ }
        cizBakilanlar();
        cizSonHaplar();
        return;
      }
      const bakilanSil = e.target.closest('[data-spk-bakilan-sil]');
      if (bakilanSil) {
        try { localStorage.setItem(BAKILAN_ANAHTAR, JSON.stringify(bakilanlar().filter((b) => b.u !== bakilanSil.dataset.spkBakilanSil))); } catch { /* depolama kapalı */ }
        cizBakilanlar();
        return;
      }
      const kaydir = e.target.closest('[data-spk-kaydir]');
      if (kaydir) {
        const s = kesfet.querySelector('[data-spk-serit]');
        s?.scrollBy({ left: Number(kaydir.dataset.spkKaydir) * s.clientWidth * 0.8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        return;
      }
      const sekme = e.target.closest('[data-spk-sekme]');
      if (sekme) {
        kesfet.querySelectorAll('[data-spk-sekme]').forEach((b) => b.setAttribute('aria-selected', String(b === sekme)));
        kesfet.querySelectorAll('[data-spk-panel]').forEach((p) => { p.hidden = p.dataset.spkPanel !== sekme.dataset.spkSekme; });
        return;
      }
      const ozSekme = e.target.closest('[data-spk-oz]');   // Özellikler: kategori sekmesi → o kategorinin özellik satırları
      if (ozSekme) {
        kesfet.querySelectorAll('[data-spk-oz]').forEach((b) => b.setAttribute('aria-selected', String(b === ozSekme)));
        kesfet.querySelectorAll('[data-spk-oz-panel]').forEach((p) => { p.hidden = p.dataset.spkOzPanel !== ozSekme.dataset.spkOz; });
        return;
      }
      const hedef = e.target.closest('[data-spk-jeton]');
      if (hedef) {   // kart / logo / hap → çip; çipe çevrilemezse koleksiyon sayfası
        e.preventDefault();
        const js = JSON.parse(hedef.dataset.spkJeton).map(idDenJeton).filter(Boolean);
        if (!jetonlariEkle(js) && js.length) window.location.href = aramaAdresi(js);
        return;
      }
      const ara = e.target.closest('[data-spk-ara]');
      if (ara) {
        input.value = ara.dataset.spkAra;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
        guncelle();   // "… için ara" satırı ve öneriler hemen gelsin (yapay input olayı guncelle'yi tetiklemiyor)
        return;
      }
      const sil = e.target.closest('[data-spk-son-sil]');
      if (sil) {
        try {
          const l = JSON.parse(localStorage.getItem(SON_ANAHTAR) || '[]');
          l.splice(Number(sil.dataset.spkSonSil), 1);
          localStorage.setItem(SON_ANAHTAR, JSON.stringify(l));
        } catch { /* depolama kapalı */ }
        cizSonHaplar();
        input.focus();
        return;
      }
      const son = e.target.closest('[data-spk-son-i]');
      if (son) sonAramayiYukle(sonAramalar()[Number(son.dataset.spkSonI)]);
    });
    cizSonHaplar();
    input.addEventListener('focus', cizSonHaplar);
  }

  /* Yazıyormuş gibi ipucu: örnek aramalar yer tutucuda harf harf yazılıp silinir (sadece panel açık, kutu boş, çip yokken) */
  (function ipucuAnimasyonu() {
    const ipucular = JSON.parse(kesfet?.dataset.spkIpucu || '[]');
    if (!ipucular.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const sabit = input.placeholder;
    let i = 0, n = 0, siliyor = false;
    const adim = () => {
      const acik = document.getElementById('search-drawer')?.hasAttribute('open');
      if (!acik || input.value || secili.length || document.hidden) {
        if (input.placeholder !== sabit) { input.placeholder = sabit; n = 0; siliyor = false; }
        return setTimeout(adim, 500);
      }
      const metin = ipucular[i];
      n += siliyor ? -1 : 1;
      input.placeholder = metin.slice(0, n) || ' ';
      if (!siliyor && n >= metin.length) { siliyor = true; return setTimeout(adim, 1700); }
      if (siliyor && n <= 0) { siliyor = false; i = (i + 1) % ipucular.length; return setTimeout(adim, 350); }
      return setTimeout(adim, siliyor ? 28 : 70);
    };
    adim();
  })();

  /* theme.js bu API ile aramayı kurar */
  /* Bitişik model kodu: "w75v2" → "w75 v2", "atk68" → "atk 68". Ürün adlarında tek kelime olarak geçmeyen harf+rakam
     kelimesi, harf/rakam sınırlarından, her parçası ürün kelimesi olacak şekilde en az parçaya bölünür (son parça
     yarım yazılmış olabilir: "w75v" → "w75 v"). Sözlük dizinde (D.sozluk); yoksa yazı olduğu gibi gider. */
  const urunKelimeleri = new Set(D.sozluk || []);
  const kelimeBasi = (p) => urunKelimeleri.has(p) || [...urunKelimeleri].some((w) => w.startsWith(p));
  function modelAyir(yazi) {
    if (!urunKelimeleri.size) return yazi;
    return yazi.split(/\s+/).map((ham) => {
      const w = norm(ham);
      if (!/[a-z]/.test(w) || !/\d/.test(w) || kelimeBasi(w)) return ham;
      const parcalar = w.match(/[a-z]+|\d+|[^a-z\d]+/g);
      let en = null;
      for (let maske = 0; maske < 1 << (parcalar.length - 1); maske++) {   // hangi sınırlarda bölüneceği (en fazla ~6 parça)
        const bolum = [parcalar[0]];
        for (let i = 1; i < parcalar.length; i++) {
          if (maske & (1 << (i - 1))) bolum.push(parcalar[i]); else bolum[bolum.length - 1] += parcalar[i];
        }
        const uygun = bolum.every((p, i) => (i === bolum.length - 1 ? kelimeBasi(p) : urunKelimeleri.has(p)));
        if (uygun && (!en || bolum.length < en.length)) en = bolum;
      }
      return en ? en.join(' ') : ham;
    }).join(' ');
  }

  // Tükenmiş kuralı (kullanıcı 15.10): ürün ADIYLA aranmıyorsa panel tükenmişleri göstermez — yazı yok (sadece çip) ya da yazının
  // tamamı kategori / filtre değeri / özellik / marka kelimesi ("cam mousepad", "lamzu"). Adla aramada ("lamzu maya") eskisi gibi.
  let kategoriTerimleri = null;
  function kategoriAramasi(yazi) {
    if (!yazi || yazi === '*') return secili.length > 0;
    kategoriTerimleri ??= [...new Set(jetonlar.filter((j) => ['kat', 'deg', 'ozl', 'mrk'].includes(j.tur)).flatMap((j) => j.t))]
      .filter((t) => t.length > 1).sort((a, b) => b.length - a.length);
    let kalan = ` ${norm(yazi)} `;
    for (const t of kategoriTerimleri) kalan = kalan.split(` ${t} `).join(' ');   // uzun terim önce ("mouse pad" → "mouse")
    return !kalan.split(' ').some((k) => k && !/^(\d+|tl|alti|altinda|ustu|ve|ile|icin)$/.test(k));
  }

  window.spotlight = {
    aktif: () => secili.length > 0,
    istek(yazi = input.value.trim()) {
      const s = sozdizimi();
      const ozellik = secili.filter((j) => j.tur === 'ozl').map((j) => j.metin);
      const q = [s, ...ozellik, yazi === '*' ? '' : modelAyir(yazi)].filter(Boolean).join(' ') || (secili.length ? '*' : '');
      const filtreler = new URLSearchParams(secili.flatMap(parametreler)).toString();
      // stok: panel ürün isteğine options[unavailable_products] (theme.js); Stokta çipi varken zaten filtreli
      const stok = !secili.some((j) => j.tur === 'stok') && kategoriAramasi(yazi) ? 'hide' : null;
      return { q, filtreler, stok };
    },
    modelAyir,
  };

  urldenKur();
})();
/* CUSTOM-END */
